import { PostResponseSchema } from '@/api/client';

/**
 * Marker color constants (matches React Native HighlightedMarker)
 */
export const MARKER_COLORS = {
  recorded: '#fc2c03',
  eventBlue: '#3b82f6',
  eventOrange: '#e86d2c',
  eventRed: '#ef4444',
  eventGray: 'rgb(120, 120, 120)',
  liveRed: '#ef4444',
  liveGray: 'rgb(120, 120, 120)',
};

/**
 * Get event marker color based on timing
 * (matches MapMarkersShapeSource.tsx logic)
 */
export function getEventColor(post: PostResponseSchema): 'blue' | 'orange' | 'red' | 'gray' {
  const now = new Date();
  const startsAt = post.starts_at;
  const endsAt = post.ends_at;

  let color: 'blue' | 'orange' | 'red' | 'gray' = 'blue'; // Default future color

  if (startsAt) {
    const startDate = new Date(startsAt);
    const hoursUntilStart = (startDate.getTime() - now.getTime()) / (1000 * 60 * 60);

    if (startDate <= now) {
      // Event has started
      if (endsAt) {
        const endDate = new Date(endsAt);
        color = endDate > now ? 'red' : 'gray'; // Live or ended
      } else {
        color = 'red'; // Live (no end time)
      }
    } else if (hoursUntilStart >= 24) {
      color = 'blue'; // More than 24 hours away
    } else if (hoursUntilStart >= 3) {
      color = 'orange'; // 3-24 hours away
    } else {
      color = 'red'; // Less than 3 hours away
    }
  }

  return color;
}

/**
 * Get event marker background color
 */
export function getEventBackgroundColor(post: PostResponseSchema): string {
  const color = getEventColor(post);
  const colorKey = `event${color.charAt(0).toUpperCase() + color.slice(1)}` as keyof typeof MARKER_COLORS;
  return MARKER_COLORS[colorKey];
}

/**
 * Check if livestream is a replay (has recorded stream)
 */
export function isLivestreamReplay(post: PostResponseSchema): boolean {
  return !!post.m3u8_url;
}

/**
 * Get livestream marker background color
 */
export function getLivestreamBackgroundColor(post: PostResponseSchema): string {
  return isLivestreamReplay(post) ? MARKER_COLORS.liveGray : MARKER_COLORS.liveRed;
}
